import { render, staticRenderFns } from "./location-restrictions.vue?vue&type=template&id=8095bb6e"
import script from "./location-restrictions.vue?vue&type=script&lang=js"
export * from "./location-restrictions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports